import BrButton from '@govbr/react-components/lib/BrButton';
import '@react-pdf-viewer/core/lib/styles/index.css';
import { useEffect, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import auth from '../../auth/Auth';
import authIdPositiva from '../../auth/AuthIdPositiva';
import { base64toObjectURL } from '../../common/converterUtils';
import { sharePdf } from '../../common/cordovaPluginUtils';
import * as mensagem from '../../common/Mensagens';
import MainContainer from '../../components/MainContainer/MainContainer';
import Message from '../../components/Message/Message';
import { selectPerfilCompleto, selectSituacaoCadastroFamilia } from '../Perfil/perfilSlice';
import styles from './Comprovante.module.css';
import stylesPagination from '../../styles/PaginationPDF.module.css';
import iconeCidada from '../../assets/img/iconeCidada.svg';
import iconeCopiar from '../../assets/img/copy-solid-blue.svg';
import {
  ativarMensagem,
  getComprovanteCadastro,
  getComprovanteCadastroIdPositiva,
  getComprovanteCadastroIdPositivaRL,
  getComprovanteCadastroRL,
  reset,
  selectFamiliaCadastrada,
  selectMensagemAtivada,
  selectPdf,
  selectComprovante,
} from './comprovanteSlice';
import { useHistory } from 'react-router-dom';
import configuration from '../../envConfig';
import Card from '../../components/Card/Card';
import { Grid, Button } from '@material-ui/core';
import FieldGroup from '../../components/FieldGroup/FieldGroup';
import moment from 'moment';
import { formatarCpf, formatarNumeroFamiliar } from '../../common/formatadores';
import { authLogout, selectGovBr } from '../../auth/authSlice';
import { selectLogado } from '../IdentificacaoPositiva/identificacaoPositivaSlice';
import { getConfiguracaoParametro, selectConfiguracaoParametro } from '../Suporte/SuporteSlice';
import { reviewDialog } from '../../platformImpl/cordova/pushLib';
import { TipoPerfil } from '../../model/TipoPerfil';
import AjudaRapida from '../../components/AjudaRapida/AjudaRapida';
import { obterNomeDoPerfil } from '../../common/perfilUtils';
import usePagination from '@mui/material/usePagination/usePagination';
import { trackServiceSelect } from '../../common/tracker';

const Comprovante: React.FC = () => {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

  const dispatch = useAppDispatch();

  const perfil = useAppSelector(selectPerfilCompleto);
  const selectedPdf = useAppSelector(selectPdf);
  const isFamiliaCadastrada = useAppSelector(selectFamiliaCadastrada);
  const mensagemAtivada = useAppSelector(selectMensagemAtivada);
  const selectedComprovante = useAppSelector(selectComprovante);
  const history = useHistory();

  const situacaoCadastroFamilia = useAppSelector(selectSituacaoCadastroFamilia);
  const govBrLogado = useAppSelector(selectGovBr).logado;
  const isAuthenticatedIdPositiva = useAppSelector(selectLogado);
  const habilitaAvaliacaoApp = useAppSelector(selectConfiguracaoParametro);

  const [numPages, setNumPages] = useState<number>();
  const [pageNumber, setPageNumber] = useState<number>(1);

  const [chaveCopiada, setChaveCopiada] = useState(false);

  const mensagemChaveSegurancaCopiada = 'Chave de segurança copiada!';

  useEffect(() => {
    let timeoutId;

    if (chaveCopiada) {
      timeoutId = setTimeout(() => {
        setChaveCopiada(false);
      }, 5000);
    }

    return () => clearTimeout(timeoutId);
  }, [chaveCopiada]);

  const isLogado = () => {
    return (govBrLogado && situacaoCadastroFamilia) || isAuthenticatedIdPositiva
    ? true
    : false;
  }

  const caixaMensagens = () => {
    trackServiceSelect('POR-MENU', "CAIXA DE MENSAGEM");
    history.push('/caixa-mensagem');
  };

  const logout = () => {
    dispatch(authLogout({ history }));
  };

  useEffect(() => {
    if (configuration.isCordova && !habilitaAvaliacaoApp){
      dispatch(getConfiguracaoParametro('HABILITA_AVALIACAO_APP'));
    }

    const dados = {
      numeroFamiliar: perfil.numeroFamiliar,
      identificador: perfil.identificador,
      cpfSolicitante: auth.getUser()
    };

    if (auth.isAuthenticated()) {
      if (perfil.tipoPerfil.codigo === TipoPerfil.REPRESENTANTE_LEGAL) {
        dispatch(getComprovanteCadastroRL(dados));
      } else {
        dispatch(getComprovanteCadastro(dados));
      }
    } else if (authIdPositiva.isAuthenticated()) {
      if (perfil.tipoPerfil.codigo === TipoPerfil.REPRESENTANTE_LEGAL) {
        dispatch(getComprovanteCadastroIdPositivaRL(dados));
      } else {
        dispatch(getComprovanteCadastroIdPositiva(dados));
      }
    }
    return () => {
      dispatch(reset());
    };
  }, [dispatch, perfil]);

  const downloadPDF = () => {
    if (configuration.isCordova) {
      sharePdf('data:application/pdf;ComprovanteDeCadastro.pdf;base64,', selectedPdf);
    } else {
      const fileURL = base64toObjectURL(selectedPdf);
      window.open(fileURL);
    }
  };

  const mostrarComoAtualizar = () => {
    history.push('/como-atualizar');
  };

  const redirectValidacaoComprovante = () => {
    history.push('/validacao-comprovante');
  };

  function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
    setNumPages(numPages);
  }

  const handleChange = async (event, value) => {
    setPageNumber(value)
  };

  const { items } = usePagination({
      count: numPages,
      onChange: handleChange
  });

  const exibirPaginacao = () => {
    return (
      <div className={stylesPagination.espacamentoPagination}>
        {(numPages != null && numPages > 1) && (
          <nav className={stylesPagination.brPagination}>
            <ul className={`${stylesPagination.brPagination} ${stylesPagination.brPaginationUl}`}>
                {items.map(({ page, type, selected, ...item }, index) => {
                  let children;

                  if (type === 'start-ellipsis' || type === 'end-ellipsis') {
                      children = <i className={` ${stylesPagination.brPaginationI}, "fas fa-ellipsis-h" `} aria-hidden="true"></i>;
                  } else if (type === 'page') {
                    if (selected) {
                      children = (
                        <button
                            className={`${stylesPagination.brPaginationPageActive} br-button circle`}
                            type="button"
                            {...item}
                        >
                          {page}
                        </button>
                      );
                    }
                    else {
                      children = (
                        <button
                            className={`${stylesPagination.brPaginationPaginationEllipsisBrButton} br-button circle `}
                            type="button"
                            {...item}
                        >
                          {page}
                        </button>
                      );
                    }

                  } else {
                      children = (
                      <button className={`${stylesPagination.brPaginationPaginationEllipsisBrButton} br-button circle`} type="button" {...item}>
                          {type === "previous" && <i className="fas fa-angle-left" aria-hidden="true"></i>}
                          {type === "next" && <i className="fas fa-angle-right" aria-hidden="true"></i>}
                      </button>
                      );
                  }
                  return <li className={`${stylesPagination.brPagination} ${stylesPagination.brPaginationLi} ${stylesPagination.brPaginationPage} `} key={index}>{children}</li>;
                })}
            </ul>
          </nav>
        )}
      </div>
    )
  }

  const copiarChaveDeSegurancaParaAreaTransferencia = () => {
    navigator.clipboard.writeText(selectedComprovante.chaveSeguranca)
      .then(() => {
        console.log('Copied to clipboard:', selectedComprovante.chaveSeguranca);
      })
      .catch((error) => {
        console.error('Failed to copy to clipboard:', error);
      });

      setChaveCopiada(true);
  }

  const exibirPreviewPDF = () => {
    if (!isFamiliaCadastrada) {
      dispatch(ativarMensagem(true));

      setTimeout(() => {
        dispatch(ativarMensagem(false));
      }, 10000);

      return (
        <>
          {mensagemAtivada && (
            <Message
              id="mensagem"
              type="warning"
              title={mensagem.MSG_TITULO_COMPROVANTE_CADASTRO_NAO_PODE_SER_EMITIDO}
              text={
                <>
                  {mensagem.MSG_TEXTO_COMPROVANTE_CADASTRO_NAO_PODE_SER_EMITIDO}&nbsp;
                  Para mais informações <span className={styles.enfaseContent}>clique aqui</span>.
                </>
              }
              className={styles.message}
              onClick={() => mostrarComoAtualizar()}
            />
          )}
        </>
      );
    }

    if (selectedPdf) {
      if (configuration.isCordova && habilitaAvaliacaoApp === 'HABILITADO') {
        setTimeout(() => { reviewDialog() }, 7000);
      }

      return (
        <>
          {!configuration.isCordova && (
            <>
              <div className={styles.previewArea}>

                {exibirPaginacao()}

                <Document file={base64toObjectURL(selectedPdf)} onLoadSuccess={onDocumentLoadSuccess} loading={"Carregando PDF..."} options={{ cMapUrl: `//cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/cmaps/`, cMapPacked: true, }}>
                  <Page width={960} pageNumber={pageNumber} />
                </Document>

                {exibirPaginacao()}

                <BrButton className={styles.button} onClick={() => downloadPDF()}>
                  Compartilhar
                </BrButton>
              </div>
            </>
          )}
          {configuration.isCordova && (
            <>
              <Card className={styles.card}>
                <Grid container spacing={2}>

                  <Grid item xs={12} sm={12}>
                    <div className={styles.tagCard}>Sua família está no Cadastro Único para Programas Sociais do Governo Federal.</div>
                  </Grid>

                  <Grid item xs={12} sm={12}>
                    <div className={styles.internalTitle}>Dados da família</div>
                  </Grid>

                  <Grid item xs={6} sm={6}>
                    <FieldGroup
                      label="Código familiar "
                      value={formatarNumeroFamiliar(selectedComprovante.numeroFamiliar)}
                    />
                  </Grid>

                  <Grid item xs={6} sm={6}>
                    <FieldGroup
                      label="Data de cadastro"
                      value={moment(selectedComprovante.dataCadastro).format('DD/MM/YYYY')}
                    />
                  </Grid>

                  <Grid item xs={6} sm={6}>
                    <FieldGroup
                      label="Última atualização"
                      value={moment(selectedComprovante.dataAtualizacao).format('DD/MM/YYYY')}
                    />
                  </Grid>

                  <Grid item xs={6} sm={6}>
                    <FieldGroup
                      label="Limite para atualização"
                      value={moment(selectedComprovante.dataLimiteParaProximaAtualizacao).format('DD/MM/YYYY')}
                    />
                  </Grid>

                  <Grid item xs={6} sm={6}>
                    <FieldGroup
                      label="Cadastro atualizado"
                      value={selectedComprovante.cadastroAtualizado}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FieldGroup
                      label="Município de cadastramento"
                      value={selectedComprovante.municipioUF}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FieldGroup
                      label="Faixa de renda familiar total"
                      value={selectedComprovante.faixaRendaFamiliarTotal}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12}>
                    <FieldGroup
                      label="Faixa de renda familiar por pessoa (per capita)"
                      value={selectedComprovante.faixaRendaFamiliarPorPessoa}
                    />
                  </Grid>

                  {selectedComprovante.ehIndigena &&
                    <>
                      <div className={styles.subInternalTitle}>Família é indígena</div>
                      <Grid item xs={12} sm={6}>
                        <FieldGroup
                          label="Povo indígena"
                          value={selectedComprovante.nomePovoIndigena}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FieldGroup
                          label="Terra ou reserva indígena"
                          value={selectedComprovante.terraOuReservaIndigena}
                          />
                      </Grid>
                    </>
                  }

                  {selectedComprovante.ehQuilombola &&
                    <>
                      <div className={styles.subInternalTitle}>Família é quilombola</div>
                      <Grid item xs={12} sm={12}>
                        <FieldGroup
                          label="Comunidade quilombola"
                          value={selectedComprovante.comunidadeQuilombola}
                        />
                      </Grid>
                    </>
                  }

                  <Grid item xs={12} sm={12}>
                    <FieldGroup
                      label="Endereço"
                      value={selectedComprovante.endereco}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12}>
                    <div className={styles.internalTitle}>Integrantes da família</div>
                    {selectedComprovante.integrantes.map((integrante, index) => {
                      return (
                        <div key={index} className={styles.containerIntegrantes}>
                          <Grid container spacing={2}>

                            <Grid item xs={12} sm={12}>
                              <FieldGroup label="Nome" value={integrante.nomePessoa} />
                            </Grid>

                            {integrante.temIdentidadeGenero === 1 && integrante.nomeSocialApelidoPessoa?.length > 1 &&
                              <Grid item xs={12} sm={12}>
                                <FieldGroup label="Nome social" value={integrante.nomeSocialApelidoPessoa} />
                              </Grid>
                            }

                            <Grid item xs={6} sm={6}>
                              <FieldGroup label="CPF" value={integrante.cpf} />
                            </Grid>

                            <Grid item xs={6} sm={6}>
                              <FieldGroup
                                label="Data de nascimento"
                                value={moment(integrante.dataNascimento).format('DD/MM/YYYY')}
                              />
                            </Grid>

                            <Grid item xs={6} sm={6}>
                              <FieldGroup label="NIS, PIS ou PASEP" value={integrante.nis} />
                            </Grid>

                            <Grid item xs={12} sm={12}>
                              <FieldGroup
                                label="Parentesco com o RF"
                                value={integrante.parentescoComRF}
                              />
                            </Grid>

                            <Grid item xs={12} sm={12}>
                              <FieldGroup
                                label="Estado cadastral"
                                value={integrante.estadoCadastral}
                              />
                            </Grid>
                          </Grid>
                        </div>
                      );
                    })}
                  </Grid>

                  <Grid item xs={12} sm={12}>
                    <div className={styles.internalTitle}>Autenticidade</div>
                    <span>
                      <strong>
                        A autenticidade poderá ser confirmada informando a chave de segurança no
                        site do Ministério do Desenvolvimento e Assistência Social, Família e Combate à Fome:{' '}
                      </strong>
                    </span>
                  </Grid>

                  <Grid item xs={12} sm={12}>
                    <div className={styles.link} onClick={redirectValidacaoComprovante}>
                      {selectedComprovante.urlValidacaoComprovante}
                    </div>
                  </Grid>
                </Grid>
                <div className={styles.qrCode}>
                  <img
                    src={`data:image/png;base64, ${selectedComprovante.qrCode}`}
                    width="250"
                    alt="AVALIACAO API logo"
                  ></img>
                </div>

                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12}>
                    <div className={styles.tituloItensDestaque}>Chave de segurança:</div>
                    <div className={styles.conteudoItensDestaque}>
                      {selectedComprovante.chaveSeguranca}
                      <span onClick={() => copiarChaveDeSegurancaParaAreaTransferencia()}>
                        <img src={iconeCopiar} className={styles.iconeCopiar} alt="Copiar chave de segurança para a área de transferência." />
                      </span>
                      <br/>
                      {chaveCopiada ? (
                        <span className={styles.chaveSegurancaCopiada}>
                          {mensagemChaveSegurancaCopiada}
                        </span>
                      ) : (
                        <span className={`${styles.chaveSegurancaCopiada} ${styles.hidden}`}>
                          {mensagemChaveSegurancaCopiada}
                        </span>
                      )}
                    </div>
                  </Grid>

                  <Grid item xs={12} sm={12}>
                    <div className={styles.tituloItensDestaque}>Consulta realizada em:</div>

                    <div className={styles.lastPadding}>
                      <div className={styles.conteudoItensDestaque}>
                        {`${moment(selectedComprovante.dataEmissao).format('DD/MM/YYYY')} às
                            ${moment(selectedComprovante.dataEmissao).format('HH:mm:ss')}`}
                      </div>
                    </div>
                  </Grid>
                </Grid>
                <img src={iconeCidada} className={styles.iconeCidada} alt="" />
              </Card>

              <Button onClick={() => downloadPDF()}>
                <div className={styles.box}>
                  <i className={`${styles.icone} fas fa-share-alt fa-2x`}></i>
                </div>
              </Button>
            </>
          )}
          <br/>
          <AjudaRapida titulo={"Para que serve o comprovante:"}>
            O comprovante de cadastramento serve como um documento que comprova o cadastro da família ou pessoa no Cadastro Único e pode ser utilizado para ter acesso a programas sociais.
          </AjudaRapida>
        </>
      );
    }
  };

  return (
    <MainContainer
      navHideArrow={!isLogado()}
      navTitle={obterNomeDoPerfil(perfil, situacaoCadastroFamilia)}
      userNav={isLogado()}
      titleBarraAuxiliar={"Comprovante de cadastro"}
      barraAuxiliar={true}
      padraoInicial={!isLogado()}
      navFixed={isLogado()}
      stoppedTitle={true}
      navCaixaMensagens={isLogado() ? caixaMensagens : undefined}
      navLogout={isLogado() ? logout : undefined}
      navSeparator={configuration.isCordova ? false : true}>
      <div className={styles.container}>{exibirPreviewPDF()}</div>
    </MainContainer>
  );
};

export default Comprovante;
